import * as ko from "knockout";
import {IKnockoutComponent, ISyncField} from "../../../index";
import {ObjectTypeId} from "../../../constants";
import {IDataset} from "./index";
import {nsSyncFields} from "../../../req/nsSyncFields";
import {_} from 'lodash';
import {validateServerDate} from "../../../util/datetime";
import {getObjectDefinition, getTelLink, isNullOrUndefined} from "../../../util/misc";
import {nsFa} from "../../fa/fn";
import {nsUserWizard} from "./nsUserWizard";
import {lm} from "../../../appContext";
import {storeObservable} from "../../../util/sessionstore";
import i = nsFa.i;
import TWizardSyncfield = nsUserWizard.TWizardSyncfield;
import summaryHtml from './summary.html?raw';

export let template = summaryHtml;

interface IParams {
    syncfields: ISyncField[]
    dataset: IDataset
}

export class viewModel {
    private readonly toggleAll: KnockoutObservable<boolean> = storeObservable("syncfields.toggle.show.all", false);

    private dataset: IDataset
    private data!: any[]
    private _syncfields: ISyncField[];

    constructor(params: IParams) {
        this._syncfields = params.syncfields
        this.dataset = params.dataset
    }

    private getDerivedValueComponent(item: ISyncField): IKnockoutComponent | null | undefined {
        return nsSyncFields.getDerivedValueComponent(item, {objectTypeId: ObjectTypeId.User, linkable: false})
    }

    private hasValue = nsSyncFields.hasValue

    private prepareValues(item: ISyncField): ISyncField[] {
        switch (item.name) {
            case 'WwwUrl':
                return item.value.split('\\').map((val: string) => {
                    const ret = _.cloneDeep(item);
                    ret.value = val.split(' ')[0];
                    return ret;
                }).filter(nsSyncFields.hasValue);
            case "APositionManager":
                return nsSyncFields.getArrayByString(item.value).map((val: string) => {
                    const ret = _.cloneDeep(item);
                    ret.value = val;
                    return ret;
                }).filter(nsSyncFields.hasValue);
            default:
                return nsSyncFields.getArrayByString(item.value).map((val: string) => {
                    const ret = _.cloneDeep(item);
                    ret.value = val;
                    return ret;
                }).filter(nsSyncFields.hasValue);
        }
    }

    private validateServerDate(str: string): boolean {
        return validateServerDate(str)
    }

    private getDerivedValue(item: ISyncField): string | null {
        const val = item.value;
        if (!val) {
            return null;
        }
        switch (item.name as TWizardSyncfield) {
            case "BusinessNumber":
                return `${i('fa-external-link')} <a href="https://w2.brreg.no/enhet/sok/detalj.jsp?orgnr=${val}" title="${lm.t('see key information from CCR')}" target="_blank">${lm.t('CCR')}</a>`;
            case "Email":
                return `${i('fa-envelope')} <a href="mailto:${val}">${lm.t('send email')}</a>`;
            case "Mobile":
                return getTelLink(val, 'fa-mobile');
            case "PrivatePhone":
            case "TelephoneNumber":
            case "WorkPhone":
                return getTelLink(val);
            case "ObjectTypeId":
                return getObjectDefinition(ObjectTypeId.User)?.singular ?? '';
            case "SourceId": // group
            case "DepartmentNumber": // department
            case 'ParentDepartmentNumber':
            case 'WwwUrl':
                if (val === "0" || val === "Root") {
                    return lm.t('root');
                }
                return null;
        }
        return null;
    }

    private syncfields = ko.pureComputed((): ISyncField[] => {
        if (this.toggleAll()) {
            return this._syncfields
        } else {
            return this._syncfields.filter(sf => !isNullOrUndefined(sf.value))
        }
    })

}
